import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./UniversityCourse.css";

const UniversityCourse = () => {
  const [courseName, setCourseName] = useState("");
  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const [getSemesters, setGetSemesters] = useState([]);
  // --------------------------------------------------
  const [semesterYear, setSemesterYear] = useState([]);
  const [selectSemesterYear, setSelectSemesterYear] = useState("");

  const navigate = useNavigate();

  const handleAddCategory = () => {
    const selectedSemester = getSemesters.find(
      (item) => item._id === selectSemesterYear
    );

    if (
      selectedSemester &&
      !semesterYear.some((s) => s._id === selectedSemester._id)
    ) {
      setSemesterYear([...semesterYear, selectedSemester]);
      setSelectSemesterYear(""); // Reset dropdown
    }
  };

  const handleRemoveCategory = (cat) => {
    setSemesterYear(semesterYear.filter((item) => item._id !== cat._id));
  };

  useEffect(() => {
    // Fetch universities list from API
    axios
      .get(`${API_BASE_URL}/universities`)
      .then((response) => {
        const universitiesData = response.data?.data || [];
        setUniversities(universitiesData);
      })
      .catch((error) => console.log(error));
  }, [API_BASE_URL]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/semesters`)
      .then((response) => {
        const semesters = response.data?.data || [];
        setGetSemesters(semesters);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (courseName && universityId && semesterYear.length > 0) {
      const payload = {
        courseName,
        universityId,
        semesterYear: semesterYear.map((s) => s._id), // Only send IDs
      };

      axios
        .post(`${API_BASE_URL}/courses`, payload)
        .then((response) => {
          console.log("Course created successfully:", response.data);
          alert("Course created successfully");
          // Reset form fields
          setCourseName("");
          setUniversityId("");
          setSemesterYear([]);
          setSelectSemesterYear("");
          navigate("/college-all-courses"); // Redirect to all courses page
          
        })
        .catch((error) => {
          console.error("Error creating course:", error);
          alert("Error creating course");
        });
    } else {
      console.log("Please fill in all required fields.");
    }
  };

  return (
    <>
      <div id="add-department-inner-wrapper">
        <div className="course-header-with-btns">
          <h5>Course</h5>

          <div className="college-course-nav-btns">
            <Link to={"/college-add-course"}>
              <button className="college-add-course-add-btn">
                + Add New Course
              </button>
            </Link>
            <Link to={"/college-all-courses"}>
              <button className="college-all-course-btn">All Courses</button>
            </Link>
          </div>
        </div>

        <div className="">
          <div className="form-school-container">
            <h4 className="college-course-detail">Course Details</h4>
            <form
              onSubmit={handleSubmit}
              className="college-course-detail-form"
            >
              <div className="input-group">
                <label className="new-chapter-label">University Name</label>
                <select
                  className="new-chapter-dropdown"
                  value={universityId}
                  onChange={(e) => setUniversityId(e.target.value)}
                  required
                >
                  <option value="">-Select University-</option>
                  {universities.map((university) => (
                    <option key={university._id} value={university._id}>
                      {university.universityName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="input-group">
                <label className="label">Course Name</label>
                <input
                  style={{
                    marginLeft: "1px",
                    borderBottomLeftRadius: "5px",
                    borderTopLeftRadius: "5px",
                  }}
                  type="text"
                  value={courseName}
                  onChange={(e) => setCourseName(e.target.value)}
                  placeholder="Enter university course name"
                  className="new-chapter-dropdown"
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Select Category</label>
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <select
                    className="school-class-add-input-tag"
                    value={selectSemesterYear}
                    onChange={(e) => setSelectSemesterYear(e.target.value)}
                  >
                    <option value="">-Select Category-</option>
                    {getSemesters &&
                      getSemesters.map((item, index) => (
                        <option
                          key={item._id}
                          value={item._id}
                          disabled={semesterYear.some(
                            (s) => s._id === item._id
                          )}
                        >
                          {item.semesterName || "N/A"}
                        </option>
                      ))}
                  </select>
                  <button
                    type="button"
                    onClick={handleAddCategory}
                    className="btn-s"
                  >
                    Add
                  </button>
                </div>
              </div>

              {/* Show selected categories with remove option */}
              {semesterYear.length > 0 && (
                <div className="selected-categories">
                  <p style={{ marginBottom: "5px" }}>Selected Categories:</p>
                  <ul>
                    {semesterYear.map((cat, index) => (
                      <li key={index} style={{ marginBottom: "5px" }}>
                        {cat.semesterName}
                        <button
                          type="button"
                          onClick={() => handleRemoveCategory(cat)}
                          style={{
                            marginLeft: "10px",
                            background: "red",
                            color: "white",
                            border: "none",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="college-course-form-btns">
                <button className="btn-search" type="submit">
                  Save
                </button>
                <button className="btn-cancel" type="button">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UniversityCourse;
